// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import ReactDOM from 'react-dom/client';
import './helios/styles/carbon-entry.scss';
import '@carbon/charts/styles.css';
import './index.css';
import { bootstrap } from './helios/bootstrap';
import { msalInstance } from './helios/config/authConfig';
import reportWebVitals from './reportWebVitals';

bootstrap(msalInstance, ReactDOM.createRoot(document.getElementById('root')!));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
